import { render, staticRenderFns } from "./createProductModel.vue?vue&type=template&id=3179fc40&scoped=true"
import script from "./createProductModel.vue?vue&type=script&lang=js"
export * from "./createProductModel.vue?vue&type=script&lang=js"
import style0 from "./createProductModel.vue?vue&type=style&index=0&id=3179fc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179fc40",
  null
  
)

export default component.exports